import Notification from '../shared/Notification';
import { useState } from 'react';
import { useCall } from '../context/CallContext';
import styles from './audio-call-button.module.css';
import { CallIcon } from './icons/Icons';

const AudioCallButton = ({
    receiverId, 
    roomId, 
    receiverName,
    receiverProfilePicture,
    callerName,
    callerProfilePicture 
}) => {
    const { initiateCall, callState } = useCall();

    // console.log('📱 CallButton rendered:', { 
    //     receiverId, 
    //     roomId,
    //     receiverName,
    //     receiverProfilePicture,
    //     callerName,
    //     callerProfilePicture,
    //     isInCall: callState.isInCall 
    // });

    const handleCall = () => {
        // console.log('\n🎯 ===== CALL BUTTON CLICKED =====');
        // console.log('   Receiver ID:', receiverId);
        // console.log('   Receiver Name:', receiverName);
        // console.log('   Room ID:', roomId);
        // console.log('   Current call state:', callState);
        
        if (!receiverId) {
            // console.error('   ❌ No receiver ID provided!');
            // alert('Cannot initiate call: No receiver ID');
            return;
        }
        
        if (!roomId) {
            // console.error('   ❌ No room ID provided!');
            // alert('Cannot initiate call: No room ID');
            return;
        }
        
        if (callState.isInCall) {
            // console.warn('   ⚠️  Already in a call');
            // alert('You are already in a call');
            return;
        }

        // console.log('   ✅ Initiating call with info...');
        initiateCall(receiverId, roomId, {
            name: receiverName || 'Unknown User',
            profilePicture: receiverProfilePicture || null,
            callerName: callerName || 'Unknown User',
            callerProfilePicture: callerProfilePicture || null
        });
        // console.log('==================================\n');
    };

    return (
        <button 
            className={styles.closeButton}
            onClick={handleCall}
            disabled={callState.isInCall}
            title={callState.isInCall ? "Already in a call" : "Call"}
        >
            <CallIcon/>
        </button>
    );
};


export default AudioCallButton;